const serviceData = {
  'video-calls': {
    title: 'Private Video Calls',
    seoTitle: 'Private Video Calls | Izzie Fox - UK Adult Content Creator',
    icon: '📹',
    heroText: 'Intimate, one-on-one video sessions where it\'s just you and me. No scripts, no rush — just a real connection.',
    sections: [
      {
        heading: 'What to expect',
        paragraphs: [
          'When you book a private video call with me, you\'re getting my full, undivided attention. I love making these sessions personal — whether you want something flirty and playful or deeper and more intimate, I\'m here for it.',
          'Every call is completely private and one-on-one. I use established platforms for my private one-to-one video calls, with discretion and privacy in mind. It\'s just you and me, in real time.'
        ]
      },
      {
        heading: 'How it works',
        paragraphs: [
          'Simply message me on WhatsApp or Telegram to arrange a mutually suitable time. I\'ll let you know everything you need before we connect.',
          'Whether it\'s your first time or you\'re a returning caller, I make sure every session feels comfortable and tailored to you.'
        ]
      }
    ]
  },
  'phone-calls': {
    title: 'Private Phone Calls',
    seoTitle: 'Private Phone Calls | Izzie Fox - UK Adult Content Creator',
    icon: '📞',
    heroText: 'Sometimes a voice is all you need. My private phone calls offer an intimate audio experience that feels personal and real.',
    pricingText: 'Contact me for current pricing and availability. I\'ll be happy to discuss the options with you before you book.',
    sections: [
      {
        heading: 'Why phone calls?',
        paragraphs: [
          'There\'s something about hearing someone\'s voice that a text just can\'t replace. My private phone calls are for adults who want a more personal one-to-one experience without the camera. It\'s relaxed, private and focused on real-time conversation.',
          'Whether you want to chat, flirt or enjoy something a little more personal, each call is one-to-one and tailored to the kind of experience you\'re looking for.'
        ]
      },
      {
        heading: 'Getting started',
        paragraphs: [
          'Message me on WhatsApp or Telegram and let me know you\'re interested in a private phone call. We\'ll arrange a mutually suitable time and discuss the details before the call. I\'m UK based and can also arrange calls with international customers.'
        ]
      }
    ]
  },
  'sexting': {
    title: 'Private Sexting with Izzie Fox',
    seoTitle: 'Private Sexting | Izzie Fox - UK Adult Content Creator',
    icon: '💬',
    heroText: 'Looking for something a little more personal? My private sexting sessions are one-to-one, playful and tailored to you. Whether you prefer flirting, teasing or a more personalised experience, we can create a session that suits what you\'re looking for.',
    pricingText: 'Contact me for current pricing and availability. Optional extras and personalised content can be discussed when booking.',
    ctaHeading: 'Ready to arrange your private sexting session?',
    ctaText: 'Contact me directly on WhatsApp or Telegram.',
    sections: [
      {
        heading: 'What\'s included',
        paragraphs: [
          'My private sexting sessions can include private one-to-one messaging along with photos and videos during the session, creating a more personal and interactive experience.',
          'Each session is between you and me — real-time, adult chat that\'s tailored to the kind of experience you\'re after.'
        ]
      },
      {
        heading: 'Optional extras',
        paragraphs: [
          'Want to make your session more personalised? Optional extras can also be arranged, including role play, voice notes, custom photos, custom video content and other personalised requests by prior agreement.',
          'Availability and pricing for extras can vary, so message me beforehand to discuss what you would like.'
        ]
      },
      {
        heading: 'How to book',
        paragraphs: [
          'Message me on WhatsApp or Telegram to arrange your private sexting session. Let me know what kind of experience you\'re interested in and I\'ll confirm my current availability, pricing and any optional extras you would like to add.'
        ]
      }
    ]
  },
  'custom-content': {
    title: 'Custom Content',
    seoTitle: 'Custom Adult Content | Izzie Fox - UK Adult Content Creator',
    icon: '📸',
    heroText: 'Personalised photos and videos created specifically for you. Tell me what you have in mind and we can discuss the details before you order.',
    pricingText: 'Custom content is priced according to the individual request. Contact me with your idea for current pricing, availability and options.',
    ctaHeading: 'Have an idea in mind?',
    ctaText: 'Message me directly on WhatsApp or Telegram to discuss your custom content request.',
    sections: [
      {
        heading: 'Made just for you',
        paragraphs: [
          'My custom content service gives you the opportunity to request personalised photos or videos based around your preferences.',
          'You can discuss the concept with me beforehand, including things such as the outfit, setting, style, theme and other details you would like included.',
          'Every request is considered individually, so message me with your ideas and I\'ll let you know what I can offer.'
        ]
      },
      {
        heading: 'Custom photos & videos',
        paragraphs: [
          'Custom content can include personalised photo sets, custom videos, specific outfits or looks, themes and scenarios, personalised details and other requests discussed in advance.',
          'If you have something particular in mind, send me the details and I\'ll confirm whether I can accommodate the request.'
        ]
      },
      {
        heading: 'How to order',
        paragraphs: [
          'Message me on WhatsApp or Telegram with your idea and as much detail as possible.',
          'Once we have agreed on the request, I\'ll confirm the price, requirements and expected timeframe before the order goes ahead.',
          'Custom content is supplied for personal use only and remains my intellectual property. Please see my Terms of Service for full details.'
        ]
      }
    ]
  },
  'content': {
    title: 'Premade Content',
    seoTitle: 'Premium Adult Content | Izzie Fox - UK Adult Content Creator',
    icon: '🎥',
    heroText: 'Browse my selection of premade adult photos and videos available to purchase without ordering custom content.',
    pricingText: 'Prices vary depending on the content selected. Contact me for my current menu, pricing and availability.',
    ctaHeading: 'Want to see what\'s currently available?',
    ctaText: 'Message me on WhatsApp or Telegram for my latest premade content menu.',
    sections: [
      {
        heading: 'What\'s available',
        paragraphs: [
          'I regularly create photo sets and videos that are available as premade content.',
          'My available content can vary, so message me to see my current menu and find out what is available at the moment.',
          'Premade content is ideal if you want to choose from content I have already created rather than placing a personalised custom order.'
        ]
      },
      {
        heading: 'Photos & videos',
        paragraphs: [
          'My premade collection can include photo sets, individual photos, videos, themed content, different outfits and looks, and other content from my current collection.',
          'Availability varies, so contact me for my current content menu.'
        ]
      },
      {
        heading: 'How to purchase',
        paragraphs: [
          'Message me directly on WhatsApp or Telegram and ask for my current premade content menu.',
          'You can choose what you would like from the available selection and I\'ll confirm the price and payment details before your purchase.',
          'Once payment has been confirmed, your chosen content will be sent to you.'
        ]
      }
    ]
  },
  'girlfriend-experience': {
    title: 'Girlfriend Experience',
    seoTitle: 'Virtual Girlfriend Experience | Izzie Fox - UK Adult Content Creator',
    icon: '💕',
    heroText: 'A more personal and attentive online experience, tailored around you. My Girlfriend Experience combines regular private interaction with personalised attention over an agreed period of time.',
    pricingText: 'Girlfriend Experience pricing depends on the duration and what you would like included. Contact me for current packages, pricing, availability and optional extras.',
    ctaHeading: 'Looking for something more personal?',
    ctaText: 'Message me on WhatsApp or Telegram to discuss your Girlfriend Experience.',
    sections: [
      {
        heading: 'What is the Girlfriend Experience?',
        paragraphs: [
          'My Girlfriend Experience (GFE) is designed for adults who want something more personal than a single session.',
          'Depending on the package we arrange, your experience can include regular private messaging, good morning or good night messages, photos, videos and ongoing conversation throughout the agreed period.',
          'The experience can be tailored around your preferences, so we\'ll discuss what you\'re looking for before your GFE begins.'
        ]
      },
      {
        heading: 'What can be included?',
        paragraphs: [
          'Depending on the package agreed, options can include regular private messaging, good morning and good night messages, photos throughout the day, videos, voice notes, flirty and intimate conversation, sexting, personalised content and other agreed extras.',
          'Exactly what is included will depend on the package arranged beforehand.'
        ]
      },
      {
        heading: 'How it works',
        paragraphs: [
          'Message me on WhatsApp or Telegram and tell me what kind of Girlfriend Experience you\'re looking for.',
          'We can discuss the length of the experience, what you would like included, any optional extras, my availability and the price before you book.',
          'Once everything has been agreed, you\'ll know exactly what is included in your package.'
        ]
      }
    ]
  },
  'dick-ratings': {
    title: 'Dick Ratings',
    seoTitle: 'Dick Ratings | Izzie Fox - UK Adult Content Creator',
    icon: '⭐',
    heroText: 'Personalised dick ratings with your choice of style and delivery. Choose the type of feedback you want and whether you\'d like your rating by text, voice note or video.',
    pricingText: 'Pricing depends on the type of rating and delivery format selected. Contact me for current pricing and availability.',
    ctaHeading: 'Ready for your rating?',
    ctaText: 'Message me on WhatsApp or Telegram to choose your rating style and format.',
    sections: [
      {
        heading: 'Choose your rating style',
        paragraphs: [
          'Tell me what kind of rating you\'re looking for before you order. Options can include kind and complimentary, honest and detailed, brutally honest, playful and teasing, or a mixture of the above.',
          'If you have a particular style in mind, just let me know when you message me.'
        ]
      },
      {
        heading: 'Choose how you receive it',
        paragraphs: [
          'Your personalised dick rating can be delivered in different formats: text rating, voice note rating or video rating.',
          'Pricing may vary depending on the format you choose, so I\'ll confirm the price before you order.'
        ]
      },
      {
        heading: 'How to order',
        paragraphs: [
          'Message me privately on WhatsApp or Telegram and tell me which type of rating you would like and whether you want text, voice note or video.',
          'I\'ll confirm the current price and availability before you send anything for your rating.'
        ]
      }
    ]
  },
  'worn-items': {
    title: 'Worn Items',
    seoTitle: 'Worn Items | Izzie Fox - UK Adult Content Creator',
    icon: '👙',
    heroText: 'Personally worn items available to order directly from me, with options discussed privately before purchase.',
    pricingText: 'Pricing depends on the item selected and any personalised options requested. Contact me for current availability, options and pricing.',
    ctaHeading: 'Looking for a particular worn item?',
    ctaText: 'Message me privately on WhatsApp or Telegram to see what\'s currently available.',
    sections: [
      {
        heading: 'Worn items available',
        paragraphs: [
          'I offer a selection of personally worn items, subject to current availability.',
          'If you\'re looking for something specific, message me privately and let me know what you have in mind. I\'ll confirm what I currently have available and the options I can offer.'
        ]
      },
      {
        heading: 'Personalised options',
        paragraphs: [
          'Depending on the item and request, personalised options may also be available.',
          'Message me with what you\'re looking for and I\'ll confirm what can be arranged, along with any additional cost.'
        ]
      },
      {
        heading: 'Discreet packaging',
        paragraphs: [
          'Orders are packaged discreetly with privacy in mind.'
        ]
      },
      {
        heading: 'How to order',
        paragraphs: [
          'Message me directly on WhatsApp or Telegram and tell me what type of worn item you\'re interested in.',
          'I\'ll confirm current availability, any personalised options, the total price and delivery details before you place your order.',
          'UK delivery only.'
        ]
      }
    ]
  }
};

export default serviceData;
